// Mobile hardware back closes a full-screen overlay instead of leaving the
// page. Same pattern as SettingAccountPicker: push a history entry tagged
// with `tag` (keeping vue-router's state), close on popstate, and pop our
// entry when the overlay is closed from the UI.
export function claimBack (tag, onBack) {
  let active = true
  window.history.pushState({ ...(window.history.state || {}), [tag]: true }, '')
  const handler = () => {
    if (!active) return
    active = false
    window.removeEventListener('popstate', handler)
    onBack()
  }
  window.addEventListener('popstate', handler)
  return function release (popEntry = true) {
    if (!active) return
    active = false
    window.removeEventListener('popstate', handler)
    if (popEntry && window.history.state && window.history.state[tag]) window.history.back()
  }
}
